<template>
  <div class="bg-white p-2 d-flex justify-content-center">
    <input accept="application/vnd.sealed.xls" type="file" @change="handleFileChange">
    <button class="btn-primary btn-sm btn" @click="printLabel">In</button>
  </div>
</template>

<script>
import * as Excel from "exceljs";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "rePrintTicket",
  data() {
    return {
      postData: [],
    }
  },
  methods: {
    handleFileChange(e) {
      this.loading(true);
      const files = e.target.files;
      let Vue = this;
      if (files.length) {
        const workbook = new Excel.Workbook();
        const reader = new FileReader()
        reader.readAsArrayBuffer(e.target.files[0])
        reader.onload = () => {
          const buffer = reader.result
          workbook.xlsx.load(buffer)
              .then(function () {
                const worksheet = workbook.getWorksheet('Sheet1');
                worksheet.eachRow({includeEmpty: true}, function (row, rowNumber) {
                  Vue.postData.push({
                    stb: row.values[1].toString(),
                    serial: row.values[2],
                    camket: row.values[3],
                    package: row.values[4] ? row.values[4] : '',
                  });
                });
              });
          this.loading(false);
        }
      }
    },
    printLabel() {
      this.loading(true);
      useJwt.post('kd/print-label', this.postData)
          .then((response) => {
            this.loading(false);
            this.$toast.success(response.data.message);
          })
          .catch((error) => {
            this.$toast.error(error.response.data.message);
            this.loading(false);
          });
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
